"use strict";

import {DataAttrFilterRule, DateFilterRule, FilterSource, GroupFiltersRule} from "./groupsListFilter";

export default class TagSwitchesSource extends FilterSource {
    // Flat list of tag jquery elements used as switches
    #switches

    constructor(switches) {
        super();
        this.#switches = switches
    }

    switch(target) {
        if (target && target.length > 0) {
            // filter-group allows tags work together as radio buttons. It's not a tag group.
            const group = target.data('filter-group');
            target.parent().children('.selected[data-filter-group="none"]').removeClass('selected')
            if (group === 'none') {
                // clear all.
                target.parent().children('.selected').removeClass('selected')
                target.addClass('selected')
            } else if (group) {
                target.parent().children('.selected[data-filter-group="' + group + '"]').not(target).removeClass('selected')
                target.toggleClass('selected')
            } else {
                target.toggleClass('selected')
            }
            if (this.#switches.filter('.selected').length === 0) {
                this.#switches.filter('[data-filter-by="clear"]').addClass('selected');
            }
            target.parent().find('[role="checkbox"]').attr('aria-checked', 'false')
            target.parent().find('.selected [role=checkbox]').attr('aria-checked', 'true')
        }
        this.trigger('update')
        return this
    }

    getActiveRules() {
        const groupRules = {}
        return this.#switches.filter('[data-filter-by].selected,[data-filter-by]:checked').map(function () {
            let elemOptions = $(this).data('filterOptions') || {}
            let listOptions = $(this).closest('.tags-list').data('filterOptions') || {}
            switch ($(this).data('filterBy')) {
                case 'tag':
                    const rule = new DataAttrFilterRule($.extend({
                        name: 'tags',
                        value: $(this).data('filter'),
                        op: 'filter',
                    }, elemOptions, listOptions))
                    // if it's part of the group then put into the group rule and remove from this list.
                    const groupTag = $(this).closest('[data-filters]');
                    if (groupTag.length > 0) {
                        const groupRule = groupRules[groupTag[0].id] || new GroupFiltersRule($.extend(
                            {name: 'tags', op: 'filter',},
                            groupTag.parent().data('filterOptions') || {},
                            groupTag.parent().closest('.tags-list').data('filterOptions') || {}
                        ))
                        groupRule.addRule(rule)
                        groupRules[groupTag[0].id] = groupRule;
                        return null;
                    } else {
                        return rule
                    }
                case 'range':
                    return new DateFilterRule($.extend({
                        op: 'filter',
                        weight: 80,
                        from: $(this).data('from'),
                        to: $(this).data('to')
                    }, elemOptions, listOptions))
                default:
                    return null
            }
        })
            .toArray()
            .concat(Object.values(groupRules))
            .filter(x => x) // remove empty.
    }

}
